import { createContext } from "react";
import type { VerifyAccountStep } from "./verifyAccountSteps";

export type VerifyAccountStepContextValue = {
	step: VerifyAccountStep;
	setStep: (step: VerifyAccountStep) => void;
};

export const VerifyAccountStepContext =
	createContext<VerifyAccountStepContextValue | null>(null);
